export const json = {
  locale: 'fr_fr',
  recipe: "Recette",
  machine: "Machine",
  task: {
    state: {
      unset: "Non défini",
      todo: "À faire",
      in_progress: "En cours",
      to_test: "À tester",
      wont_fix: "Ne sera pas corrigé",
      done: "Terminé",
      paused: "En pause",
    },
    priority: {
      unset: "Sans priorité",
      low: "Basse",
      normal: "Normale",
      high: "Haute",
      max: "Urgente",
    },
    table: {
      header: {
        title: "Tâche",
        state: "État",
        priority: "Priorité",
        labels: "Étiquettes",
      },
      placeholder: {
        filter: {
          priority: "Filtrer les emails...",
        },
      },
      "no-results": "Aucun résultat",
    },
    add: {
      title: "Ajouter une nouvelle tâche",
      name: "Nom de la tâche",
      name_placeholder: "Entrez le nom de la tâche",
      priority: "Priorité",
      title_translations: "Traductions du titre",
      description_translations: "Traductions de la description",
      icon_url: "URL de l'icône (optionnel)",
      icon_url_placeholder: "Entrez l'URL de l'icône",
      labels: "Étiquettes",
      assigned_to: "Assigné à",
      assigned_to_placeholder: "Sélectionner un modérateur",
      submit: "Créer la tâche",
      cancel: "Annuler",
      edit_translations: "Modifier les traductions",
      save_translations: "Enregistrer les traductions",
      required_field: "Ce champ est obligatoire",
      en_us_required: "La traduction en anglais (US) est obligatoire",
      success: "Tâche créée avec succès !",
      error: "Erreur lors de la création de la tâche. Veuillez réessayer.",
    },
  },
  table: {
    select: {
      of: "sur",
      rows: "ligne(s) sélectionnée(s).",
    },
  },
  cookies: {
    link: 'Politique de cookies',
    title: "Consentement aux cookies",
    description:
      "Ce site utilise des cookies pour assurer son bon fonctionnement et améliorer votre expérience. Veuillez sélectionner les cookies que vous nous autorisez à utiliser.",
    policy_link: "En savoir plus dans notre Politique de cookies",
    accept_all: "Tout accepter",
    accept_selected: "Accepter la sélection",
    accept_essential: "Essentiels uniquement",
    manage: "Gérer les préférences",
    save: "Enregistrer les préférences",
    back: "Retour",
    categories: {
      essential: {
        title: "Cookies essentiels",
        description: "Ces cookies sont nécessaires au fonctionnement du site et ne peuvent pas être désactivés.",
      },
      functional: {
        title: "Cookies fonctionnels",
        description: "Ces cookies permettent des fonctionnalités et des personnalisations avancées.",
      },
      analytics: {
        title: "Cookies analytiques",
        description: "Ces cookies nous aident à comprendre comment les visiteurs interagissent avec le site.",
      },
      marketing: {
        title: "Cookies marketing",
        description: "Ces cookies sont utilisés pour suivre les visiteurs sur les sites web à des fins publicitaires.",
      },
    },
    expiration: {
      title: "Expiration des cookies",
      description: "Choisissez la durée pendant laquelle vos préférences de cookies seront mémorisées :",
      thirty_days: "30 jours",
      ninety_days: "90 jours",
      six_months: "6 mois",
      one_year: "1 an",
    },
    policy: {
      title: "Politique de cookies",
      introduction:
        "Cette Politique de cookies explique comment nous utilisons les cookies et technologies similaires pour vous reconnaître lorsque vous visitez notre site web. Elle explique ce que sont ces technologies et pourquoi nous les utilisons, ainsi que vos droits pour contrôler notre utilisation de celles-ci.",
      what_are_cookies: "Que sont les cookies ?",
      what_are_cookies_text:
        "Les cookies sont de petits fichiers de données placés sur votre ordinateur ou appareil mobile lorsque vous visitez un site web. Les cookies sont largement utilisés par les propriétaires de sites web pour faire fonctionner leurs sites, ou les faire fonctionner plus efficacement, ainsi que pour fournir des informations de rapport.",
      how_we_use: "Comment nous utilisons les cookies",
      how_we_use_text:
        "Nous utilisons les cookies pour plusieurs raisons. Certains cookies sont nécessaires pour des raisons techniques afin que notre site web puisse fonctionner, et nous les appelons cookies 'essentiels' ou 'nécessaires'. D'autres cookies nous permettent de suivre et de cibler les intérêts de nos utilisateurs pour améliorer l'expérience sur notre site web. Des tiers déposent des cookies via notre site web à des fins publicitaires, d'analyse et autres.",
      types: "Types de cookies que nous utilisons",
      managing: "Gestion de vos cookies",
      managing_text:
        "Vous pouvez configurer ou modifier les contrôles de votre navigateur web pour accepter ou refuser les cookies. Si vous choisissez de refuser les cookies, vous pourrez toujours utiliser notre site web, bien que votre accès à certaines fonctionnalités et zones de notre site web puisse être limité. Comme les moyens par lesquels vous pouvez refuser les cookies via les contrôles de votre navigateur web varient d'un navigateur à l'autre, vous devriez consulter le menu d'aide de votre navigateur pour plus d'informations.",
      third_party: "Cookies tiers",
      third_party_text:
        "En plus de nos propres cookies, nous pouvons également utiliser divers cookies tiers pour signaler les statistiques d'utilisation du site web, diffuser des publicités sur et via le site web, et ainsi de suite.",
      updates: "Mises à jour de cette Politique de cookies",
      updates_text:
        "Nous pouvons mettre à jour cette Politique de cookies de temps à autre afin de refléter, par exemple, des changements aux cookies que nous utilisons ou pour d'autres raisons opérationnelles, légales ou réglementaires. Veuillez donc revisiter régulièrement cette Politique de cookies pour rester informé de notre utilisation des cookies et des technologies connexes.",
      purpose: "Objectif",
      essential_purpose:
        "Nécessaires au bon fonctionnement du site web. Ces cookies permettent des fonctions de base comme la navigation des pages et l'accès aux zones sécurisées du site web.",
      functional_purpose:
        "Permettent au site web de se souvenir des choix que vous faites (comme votre nom d'utilisateur, votre langue ou la région dans laquelle vous vous trouvez) et offrent des fonctionnalités améliorées et plus personnelles.",
      analytics_purpose:
        "Nous aident à comprendre comment les visiteurs interagissent avec notre site web en collectant et en rapportant des informations de manière anonyme.",
      marketing_purpose:
        "Utilisés pour suivre les visiteurs sur les sites web. L'intention est d'afficher des publicités qui sont pertinentes et engageantes pour l'utilisateur individuel.",
      always_active: "Toujours actif",
      active: "Actif",
      inactive: "Inactif",
      back_to_site: "Retour au site",
    },
  },
  sidebar: {
    platform: "Plateforme",
    dashboard: "Tableau de bord",
    tasks: {
      title: "Tâches",
      add: "Ajouter une tâche"
    },
    analytics: "Analyses",
    users: "Utilisateurs",
    settings: "Paramètres",
    admin_panel: {
      title: "Panneau d'administration",
      mods: {
        title: "Modérateurs",
        add: "Ajouter un modérateur"
      },
      labels: {
        title: "Étiquettes",
        add: "Ajouter une étiquette"
      },
      pending: "Approbations en attente"
    },
    documentation: {
      title: "Documentations",
      create: "Créer une documentation"
    },
    search: "Rechercher dans les docs..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "Aperçu",
          userInfo: "Informations utilisateur",
          userId: "ID utilisateur",
          role: "Rôle",
          memberSince: "Membre depuis"
        },
        tasks: {
          title: "Tâches",
          assigned: "Tâches assignées",
          noTasks: "Aucune tâche assignée pour le moment."
        },
        activity: {
          title: "Activité",
          recent: "Activité récente",
          noActivity: "Aucune activité récente."
        },
        settings: {
          title: "Paramètres",
          user: "Paramètres utilisateur",
          admin: "Paramètres administrateur pour cet utilisateur."
        }
      }
    },
    mods: {
      error: {
        unknownError: "Erreur inconnue"
      },
      access: {
        title: "Accès refusé",
        description: "Vous n'avez pas la permission d'accéder à cette page."
      },
      add: {
        link: "Ajouter un nouveau mod",
        title: "Ajouter un nouveau mod",
        addDesc: "Créer une nouvelle entrée de mod",
        name: {
          title: "Nom",
          placeholder: "Entrez le nom du mod"
        },
        description: {
          title: "Description",
          placholder: "Entrez la description en "
        },
        optional: "Optionnel",
        versions: {
          title: "Versions",
          add: "Ajouter une version"
        },
        icon: "URL de l'icône",
        launchers: "Lanceurs",
        form: {
          errors: {
            alert: {
              title: "Erreur",
              description: "Veuillez corriger les erreurs ci-dessus avant de soumettre."
            },
            name: "Le nom est requis",
            description: "La description en anglais (US) est requise",
            curseforge: "Le lien CurseForge est requis",
            invalidURL: "Format d'URL invalide",
            versions: "Au moins une version est requise",
            launchers: "Au moins un lanceur est requis"
          }
        },
        cancel: "Annuler",
        create: {
          loading: "Création en cours...",
          default: "Créer le mod"
        },
        langDataError: "Erreur lors du chargement des données linguistiques :",
      },
      noMods: "Aucun mod trouvé",
      getStarted: "Commencez par créer un nouveau mod.",
      fetch: {
        error: 'Erreur lors de la récupération de la documentation :'
      },
      "delete": {
        link: "Supprimer",
        confirm: "Êtes-vous sûr de vouloir supprimer ce mod ?"
      },
      toast: {
        delete: {
          success: {
            title: "Mod supprimé",
            description: "Le mod a été supprimé avec succès."
          },
          error: {
            console: "Erreur lors de la suppression du mod :",
            fallback: "Échec de la suppression du mod",
            title: "Erreur",
            description: "Une erreur s'est produite lors de la suppression du mod."
          }
        },
        edit: {
          success: {
            title: "Succès",
            description: "Mod mis à jour avec succès"
          }
        },
        add: {
          fallback: "Échec de la création du mod",
          success: {
            title: "Succès",
            description: "Mod créé avec succès"
          },
          console: "Erreur lors de la création du mod :",
          error: {
            title: "Erreur",
            description: "Échec de la création du mod"
          }
        }
      },
      noDesc: "Aucune description disponible",
      docs: {
        link: "Docs"
      },
      edit: {
        link: "Modifier",
        title: "Modifier le mod",
        langDataError: "Erreur lors du chargement des données linguistiques :",
        notFound: "Mod non trouvé",
        failFetch: "Échec de la récupération du mod",
        unknownError: "Une erreur inconnue s'est produite",
        form: {
          errors: {
            name: "Le nom est requis",
            description: "La description en anglais (US) est requise",
            curseforge: "Le lien CurseForge est requis",
            versions: "Tous les champs de version doivent être remplis",
            launchers: "Au moins un lanceur doit être sélectionné"
          }
        },
        modInfo: "Informations sur le mod",
        editModInfo: "Modifier les informations du mod.",
        name: "Nom",
        description: {
          title: "Description",
          required: "La description en anglais (US) est requise."
        },
        optional: "Optionnel",
        versions: {
          title: "Versions",
          add: "Ajouter une version",
          remove: "Supprimer"
        },
        icon: "URL de l'icône",
        launchers: "Lanceurs",
        cancel: "Annuler",
        update: "Mettre à jour le mod"
      }
    },
    docs: {
      access: {
        title: "Accès refusé",
        description: "Vous n'avez pas la permission d'accéder à cette page."
      },
      title: "Documentation",
      description: "Parcourir et lire la documentation des mods Minecraft",
      create: {
        link: "Créer une documentation",
        tab: "Créer nouveau",
        content: {
          title: "Aucun mod disponible",
          description: "Tous les mods ont déjà une documentation ou vous n'avez pas la permission de créer une documentation pour un mod."
        },
        title: "Créer une documentation"
      },
      published: "Publié",
      pending: "En attente",
      noDocs: {
        title: "Aucune documentation disponible",
        description: "Il n'y a pas encore de pages de documentation publiées."
      },
      noPending: {
        title: "Aucune documentation en attente",
        superAdmin: "Il n'y a pas de pages de documentation en attente d'approbation",
        rest: "Vous n'avez pas de pages de documentation en attente."
      },
      user: {
        noDocs: {
          title: "Aucune documentation disponible",
          description: "Il n'y a pas encore de pages de documentation publiées."
        }
      },
      card: {
        pending: "En attente d'approbation",
        view: "Voir",
        edit: "Modifier"
      },
      add: {
        title: "Créer une nouvelle documentation",
        description: "Créer une documentation complète pour un mod Minecraft",
        noMods: {
          title: "Aucun mod disponible",
          description: "Il n'y a pas de mods disponibles pour la création de documentation. Soit tous les mods ont déjà une documentation, soit vous n'avez pas la permission de créer une documentation pour un mod."
        },
        card: {
          title: "Informations de base",
          description: "Fournir des informations de base sur la documentation.",
          descriptionLink: "Voir notre guide de documentation",
          content: {
            modSelect: "Sélectionner un mod",
            modSelectDesc: "Sélectionnez le mod pour lequel vous souhaitez créer une documentation",
            noDesc: "Aucune description disponible",
            form: {
              title: {
                title: "Titre",
                placeholder: "Entrez le titre de la documentation",
                description: "Le titre de votre documentation (l'anglais US est requis)"
              },
              description: {
                title: "Description",
                placeholder: "Entrez la description de la documentation",
                description: "Une brève description de votre documentation (l'anglais US est requis)"
              },
              coverImage: {
                title: "URL de l'image de couverture (Optionnel)",
                description: "Fournir une URL pour l'image de couverture de votre documentation"
              },
              tabs: {
                preview: {
                  title: "Aperçu",
                  content: {
                    title: "Aperçu",
                    description: "Aperçu de l'apparence de votre documentation",
                    form: {
                      title: "Titre de la documentation",
                      description: "La description de la documentation apparaîtra ici."
                    },
                    section: "section",
                    article: "article",
                    modSelect: {
                      title: "Sélectionner un mod",
                      description: "Sélectionnez un mod pour prévisualiser votre documentation"
                    }
                  }
                },
                information: {
                  title: "Informations",
                  content: {
                    title: "Informations",
                    description: "Informations importantes sur la création de documentation",
                    approval: {
                      title: "Approbation requise",
                      description: "La documentation créée par les éditeurs et les administrateurs nécessite l'approbation d'un super administrateur avant de devenir publique. Ouvrez un ticket pour le demander."
                    },
                    after: {
                      title: "Après la création :",
                      list: {
                        one: "Vous serez redirigé vers l'éditeur de documentation",
                        two: "Une section et un article par défaut seront créés automatiquement",
                        three: "Vous pouvez ajouter plus de sections et d'articles selon vos besoins",
                        four: "Vous pouvez télécharger des images et ajouter des composants personnalisés",
                        five: "Vous pouvez prévisualiser votre documentation avant de la soumettre pour approbation. (Elle doit être sauvegardée avant la prévisualisation)"
                      }
                    },
                    create: {
                      loading: "Création en cours...",
                      default: "Créer la documentation"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "Échec de la récupération des mods",
          documentation: "Échec de la récupération des documentations"
        },
        success: {
          title: "Documentation créée",
          description: "Votre documentation a été créée avec succès."
        },
        error: {
          fetching: {
            mods: {
              console: "Erreur lors de la récupération des mods :",
              toast: {
                title: "Erreur",
                description: "Échec du chargement des mods. Veuillez réessayer."
              }
            }
          },
          creating: {
            failed: "Échec de la création de la documentation",
            error: {
              console: "Erreur lors de la création de la documentation :",
              toast: {
                title: "Erreur",
                description: "Échec de la création de la documentation. Veuillez réessayer."
              }
            }
          }
        }
      }
    }
  }
}